import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { AlertCircle, Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const res = await api.exchangeSession(session_id, null);
        setUser(res.user);
        // Clean up URL
        window.history.replaceState({}, document.title, "/");
        navigate("/", { replace: true, state: { user: res.user } });
      } catch (e) {
        const detail =
          e.response?.data?.detail ||
          "We could not sign you in. Please try again or contact the admin.";
        setError(detail);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-slate-900 border border-slate-800 rounded-2xl p-8 text-center">
        {error ? (
          <>
            <div className="w-12 h-12 rounded-full bg-rose-500/15 border border-rose-500/30 flex items-center justify-center mx-auto">
              <AlertCircle className="text-rose-400" />
            </div>
            <h2 className="mt-4 text-white font-semibold">Access denied</h2>
            <p className="mt-2 text-sm text-slate-400">{error}</p>
            <button
              onClick={() => navigate("/login", { replace: true })}
              className="mt-5 px-4 py-2 rounded-md bg-emerald-500 hover:bg-emerald-400 text-slate-950 text-sm font-semibold"
            >
              Back to sign in
            </button>
          </>
        ) : (
          <>
            <Loader2 className="animate-spin text-emerald-400 mx-auto" size={32} />
            <h2 className="mt-4 text-white font-semibold">Signing you in…</h2>
            <p className="mt-2 text-sm text-slate-400">One moment please.</p>
          </>
        )}
      </div>
    </div>
  );
}
